import InvStratDiversifications from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversifications/inv-strat-diversifications.vue';

export default {
  name: 'inv-strat-diversification-container',
  components: {
    InvStratDiversifications,
  },
  methods: {
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
};
